<template>
  <div class="container">
    <container :active_path="path" :plate="'项目巡览'">
      <div class="base-warp">
        <div class="head">
          <el-form :model="search" ref="form" label-width="80px" :inline="true" size="normal">
            <el-form-item label="名称">
              <el-input v-model="search.entryname" size="mini" placeholder="请输入项目名称"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="mini" @click="confirm">搜索</el-button>
              <el-button type="primary" size="mini" @click="opendialo">添加项目</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div>
          <el-dialog v-bind="$attrs" v-on="$listeners" :visible.sync="dialogVisible" title="项目" width="40%">
            <el-row :gutter="15">
              <el-form ref="elform" :model="formData" :rules="rules" size="small" label-width="100px"
                label-position="left">
                <el-col :span="16">
                  <el-form-item label="所属城市" prop="city">
                    <el-select v-model="formData.city" placeholder="请选择城市">
                      <el-option v-for="(item, index) in cityData" :key="index" :label="item.label" :value="item.id" />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="16">
                  <el-form-item label="项目名称" prop="entryname">
                    <el-input v-model="formData.entryname" placeholder="请输入项目名称" show-word-limit clearable
                      prefix-icon='el-icon-s-opportunity' :style="{ width: '100%' }"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="16">
                  <el-form-item label="项目类型" prop="">
                    <el-radio v-model="formData.radio" :label="1">工(园区)</el-radio>
                    <el-radio v-model="formData.radio" :label="2">宸(写字楼)</el-radio>
                    <el-radio v-model="formData.radio" :label="3">荟(商业)</el-radio>
                    <el-radio v-model="formData.radio" :label="4">别墅</el-radio>
                  </el-form-item>
                </el-col>
                <el-col :span="16">
                  <el-form-item label="项目状态" prop="">
                    <el-checkbox-group v-model="formData.status" :min="1" size="mini">
                      <el-checkbox v-for="(item, index) in statusoptions" :key="index" :label="item.label">{{
                        item.label }}</el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                </el-col>
                <el-col :span="22">
                  <el-form-item label="项目标签">
                    <el-checkbox-group v-model="formData.itemlabel" :min="1" size="mini">
                      <el-checkbox v-for="(item, index) in itemlabelOptions" :key="index" :label="item.label">{{
                        item.label }}</el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                </el-col>
                <el-col :span="22">
                  <el-form-item label="项目楼层" prop="Projectfloor">
                    <el-input v-model="formData.Projectfloor" placeholder="请输入项目楼层例如:8F/9F" clearable
                      :style="{ width: '100%' }"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="22">
                  <el-form-item label="项目地址" prop="adress">
                    <el-input v-model="formData.adress" placeholder="请输入项目地址" clearable
                      :style="{ width: '100%' }"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="22">
                  <el-form-item label="项目面积" prop="projectarea">
                    <el-input v-model="formData.projectarea" placeholder="请输入项目面积例如: 6000m²" clearable
                      :style="{ width: '100%' }"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="22">
                  <el-form-item label="产业方向" prop="cyfx">
                    <el-input v-model="formData.cyfx" placeholder="请输入产业方向" clearable :style="{ width: '100%' }"
                      type="textarea"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="22">
                  <el-form-item label="相册">
                    <div class="left-row">
                      <el-carousel :interval="4000" type="card" height="200px">
                        <el-carousel-item v-for="(item, index) in album" :key="index">
                          <el-image class="img" :src="item.path" fit="scale-down"></el-image>
                          <div class="name">{{ item.name }}</div>
                        </el-carousel-item>
                      </el-carousel>
                    </div>
                    <div class="right-edit-box">
                      <addalbum :ref="album" :falbum="album" @albumok="albumokevent" :id="formData.id"></addalbum>
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="22">
                  <el-form-item label="区位优势" prop="advantage">
                    <el-input v-model="formData.advantage" type="textarea" placeholder="请输入区位优势,项目介绍"
                      :autosize="{ minRows: 4, maxRows: 4 }" :style="{ width: '100%' }"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="22">
                  <el-form-item label="设计风格" prop="Design">
                    <el-input v-model="formData.Design" type="textarea" placeholder="请输入设计风格"
                      :autosize="{ minRows: 4, maxRows: 4 }" :style="{ width: '100%' }"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="22">
                  <el-form-item label="项目评分" prop="rating">
                    <el-rate v-model="formData.rating" show-score></el-rate>
                  </el-form-item>
                </el-col>
                <el-col :span="22">
                  <el-form-item label="服务配套" prop="servicePackage">
                    <el-checkbox-group v-model="formData.servicePackage" :min="1" size="mini">
                      <el-checkbox v-for="item in servicePackage" :key="item.id" :label="item.name">{{ item.name
                      }}</el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                </el-col>
                <el-col :span="22">
                  <el-form-item label="酒店" prop="hotel">
                    <el-input v-model="formData.hotel" type="textarea" placeholder="请输入附近的酒店"
                      :autosize="{ minRows: 4, maxRows: 4 }" :style="{ width: '100%' }"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="22">
                  <el-form-item label="银行" prop="bank">
                    <el-input v-model="formData.bank" type="textarea" placeholder="请输入附近的银行"
                      :autosize="{ minRows: 4, maxRows: 4 }" :style="{ width: '100%' }"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="22">
                  <el-form-item label="购物中心" prop="ShoppingMall">
                    <el-input v-model="formData.ShoppingMall" type="textarea" placeholder="请输入附近的购物中心"
                      :autosize="{ minRows: 4, maxRows: 4 }" :style="{ width: '100%' }"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="22">
                  <el-form-item label="餐饮" prop="Restaurant">
                    <el-input v-model="formData.Restaurant" type="textarea" placeholder="请输入附近的餐饮"
                      :autosize="{ minRows: 4, maxRows: 4 }" :style="{ width: '100%' }"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="22">
                  <el-form-item label="政府机构" prop="government">
                    <el-input v-model="formData.government" type="textarea" placeholder="请输入附近的政府机构"
                      :autosize="{ minRows: 4, maxRows: 4 }" :style="{ width: '100%' }"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="22">
                  <el-form-item label="景点" prop="Attractions">
                    <el-input v-model="formData.Attractions" type="textarea" placeholder="请输入附近的景点景点"
                      :autosize="{ minRows: 4, maxRows: 4 }" :style="{ width: '100%' }"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="22">
                  <el-form-item label="视频封面" prop="videoCover">
                    <el-upload class="avatar-uploader" action="/api/Upload/uploadfilevsnologo/" :show-file-list="false"
                      :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                      <img v-if="formData.videoCover" :src="formData.videoCover" class="videoCoverimg">
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                  </el-form-item>
                </el-col>
                <el-col :span="22">
                  <el-form-item label="视频上传">
                    <el-upload ref="myVideo" class="avatar-uploader el-upload--text" name="file"
                      action="/api/Upload/uploadfilevsnologo/" :show-file-list="false" :on-success="handleVideoSuccess"
                      :before-upload="beforeUploadVideo" :on-progress="uploadVideoProcess">
                      <video v-if="videoForm.storageurl != '' && videoFlag == false" :src="videoForm.storageurl"
                        class="avatar" controls="controls">
                        您的浏览器不支持视频播放
                      </video>
                      <i v-else-if="videoForm.storageurl == '' && videoFlag == false"
                        class="el-icon-plus avatar-uploader-icon" />
                      <el-progress v-if="videoFlag == true" type="circle" :percentage="videoUploadPercent"
                        style="margin-top:30px;" />
                    </el-upload>

                  </el-form-item>
                </el-col>
                <el-col :span="22">
                  <el-form-item label="排序权值">
                    <el-input type="number" v-model="formData.listorder" placeholder="排序权值"></el-input>
                  </el-form-item>
                </el-col>
              </el-form>
            </el-row>
            <div slot="footer">
              <el-button @click="close">取消</el-button>
              <el-button type="primary" @click="handleConfirm">确定</el-button>
            </div>
          </el-dialog>
        </div>
        <div class="table-box">
          <el-table :data="tabledata" border size="mini"
            :header-cell-style="{ background: '#f7f7f7', color: '#999', textAlign: 'center', fontWeight: 'normal' }">
            <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
            <el-table-column prop="listorder" label="排序数字" width="70" align="center"></el-table-column>
            <el-table-column prop="area_name" label="所属城市" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column prop="entryname" label="项目名称" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column prop="adress" label="项目地址" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column prop="projectarea" label="项目面积" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column prop="Projectfloor" label="项目楼层" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column prop="type" label="项目类型" show-overflow-tooltip align="center">
              <template slot-scope="s">
                <el-button disabled type="warning" v-if="s.row.type === 1" size="mini">工 (园区)</el-button>
                <el-button disabled type="warning" v-if="s.row.type === 2" size="mini">宸（写字楼</el-button>
                <el-button disabled type="warning" v-if="s.row.type === 3" size="mini">荟（商业）</el-button>
                <el-button disabled type="warning" v-if="s.row.type === 4" size="mini">荟（商业）</el-button>
              </template>
            </el-table-column>
            <el-table-column prop="index" label="操作" width="210">
              <template slot-scope="s">
                <el-button type="warning" v-if="s.row.putaway" size="mini" @click="putaway(s.row)">下架</el-button>
                <el-button type="success" v-if="!s.row.putaway" size="mini" @click="putaway(s.row)">上架</el-button>
                <el-button type="danger" size="mini" @click="delbbtn(s.row)">删除</el-button>
                <el-button type="primary" size="mini" @click="editbtn(s.row)" plain>编辑</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination class="page-tion" @current-change="currentChange" layout="prev, pager, next" :page-size="pagesize"
          :total="total" background>
        </el-pagination>
      </div>
    </container>
    <router-view></router-view>
  </div>
</template>

<script>
import container from "../../../components/container"
import addalbum from '../../../components/c/addalbum'; //相册
// import Videos from "../../../components/activitys/videos.vue"; //视频

export default {
  components: {
    container, addalbum,
  },
  data () {
    return {
      path: '/reallyWillBuy/tour',
      search: {
        entryname: '',
      },
      videoForm: {
        storageurl: ''
      },
      dialogVisible: false,
      pageNo: 1,
      pagesize: 14,
      formData: {
        city: '',
        id: '',
        entryname: '',              //项目名称
        itemlabel: [],              //项目标签
        Projectfloor: undefined,    //项目楼层
        adress: undefined,           //项目地址
        projectarea: undefined,     //项目面积
        cyfx: undefined,            //产业方向
        advantage: undefined,       //区位优势
        Design: undefined,          //设计风格
        rating: 0,                  //项目评分
        Projectimage: null,         //项目图片
        hotel: undefined,           //酒店
        bank: undefined,            //银行
        ShoppingMall: undefined,    //购物中心
        Restaurant: undefined,      //餐饮
        government: undefined,      //政府机构
        Attractions: undefined,     //景点
        // featureSpace:[],         //功能空间
        servicePackage: [],         //服务配套
        listorder: null,             //排序
        videoCover: null,            //视频封面
        videoUrl: '',         //视频地址
        radio: '',                   //项目类型
        type: '',
        status: [],
        // eslint-disable-next-line no-dupe-keys
        cyfx: ''
      },
      rules: {
        city: [
          { required: true, message: '请选择关联项目', trigger: 'blur' }
        ],
        entryname: [{
          required: true,
          message: '请输入项目名称',
          trigger: 'blur'
        }],
        itemlabel: [{
          required: true,
          type: 'array',
          message: '请至少选择一个标签',
          trigger: 'change'
        }],
        Projectfloor: [{
          required: true,
          message: '请输入项目楼层例如:8F/9F',
          trigger: 'blur'
        }],
        projectarea: [{
          required: true,
          message: '请输入项目面积例如: 6000m²',
          trigger: 'blur'
        }],
        cyfx: [{
          required: true,
          message: '请输入项目产业方向',
          trigger: 'blur'
        }],
        advantage: [{
          required: true,
          message: '请输入区位优势,项目介绍',
          trigger: 'blur'
        }],
        Design: [{
          required: true,
          message: '请输入设计风格',
          trigger: 'blur'
        }],
        rating: [{
          required: true,
          message: '项目评分不能为空',
          trigger: 'change'
        }],
        Projectimage: [{
          required: true,
          message: '请确认图片上传',
          trigger: 'blur'
        }],
        hotel: [{
          required: true,
          message: '请输入附近的酒店',
          trigger: 'blur'
        }],
        bank: [{
          required: true,
          message: '请输入附近的银行',
          trigger: 'blur'
        }],
        ShoppingMall: [{
          required: true,
          message: '请输入附近的购物中心',
          trigger: 'blur'
        }],
        Restaurant: [{
          required: true,
          message: '请输入附近的餐饮',
          trigger: 'blur'
        }],
        government: [{
          required: true,
          message: '请输入附近的政府机构',
          trigger: 'blur'
        }],
        Attractions: [{
          required: true,
          message: '请输入附近的景点景点',
          trigger: 'blur'
        }],
        adress: [{
          required: true,
          message: '请输入项目地址',
          trigger: 'blur'
        }],
      },
      itemlabelOptions: [
        {
          "label": "商务配套",
          "value": 1
        }, {
          "label": "邻近地铁",
          "value": 2
        }, {
          "label": "交通便利",
          "value": 3
        }, {
          "label": "临近停车位",
          "value": 4
        }, {
          "label": "环境优美",
          "value": 5
        }
      ],
      statusoptions: [
        {
          "label": "可租可售",
          "value": 1
        }, {
          "label": "分租整租",
          "value": 2
        }, {
          "label": "整租",
          "value": 3
        }, {
          "label": "分租",
          "value": 4
        }, {
          "label": "整售",
          "value": 5
        }, {
          "label": "散售",
          "value": 6
        }
      ],
      album: [],//相册
      tabledata: [],
      total: 0,
      // projectImage: '',
      servicePackage: [],
      urlFile: '',
      videoFlag: false,
      cityData: []
    }
  },
  mounted () {
    this.getTableData()
    this.getproject();
    this.getCityList();

  },
  methods: {
    getCityList () {
      this.$api.getCityList('').then(
        data => {
          this.cityData = data;
          console.log(this.cityData, 'citydata');
        }
      )
    },
    opendialo () {
      this.dialogVisible = true
      this.formData.id = null
      this.formData.entryname = ''
      this.formData.itemlabel = []
      this.formData.status = []

      this.formData.Projectfloor = undefined
      this.formData.adress = undefined
      this.formData.projectarea = undefined
      this.formData.cyfx = undefined
      this.formData.advantage = undefined
      this.formData.Design = undefined
      this.formData.rating = 0
      this.formData.Projectimage = null
      this.formData.hotel = undefined
      this.formData.bank = undefined
      this.formData.ShoppingMall = undefined
      this.formData.Restaurant = undefined
      this.formData.government = undefined
      this.formData.Attractions = undefined
      this.formData.servicePackage = []
      this.formData.listorder = null
      this.formData.videoCover = null
      this.formData.videoUrl = undefined
    },
    //编辑回显
    editbtn (row) {
      // console.log(this.$refs,'---'); 
      this.$refs.album = []
      this.dialogVisible = true
      this.formData = row
      this.formData.id = row.id
      this.formData.itemlabel = row.itemlabel
      this.formData.status = row.status
      //this.videoFlag =  true,
      this.videoForm.storageurl = row.videoUrl
      console.log(row.itemlabel,'---')
      //this.videoFlag = false
      // this.formData.radio = row.type
      this.$set(this.formData, 'radio', row.type)
      // this.$set(this.formData, 'status', row.status)



      var newimage = row.Projectimage
      var imagearray = []
      for (var i in newimage) {
        imagearray.push(newimage[i]);
      }
      var mergedArray = imagearray.flatMap(obj => Object.values(obj));

      this.album = mergedArray

    },
    //删除
    delbbtn (row) {
      this.$confirm("是否确定删除" + row.entryname).then(
        (confirm) => {
          var params = {
            id: row.id
          };
          this.$api.delprojectTour(params).then((data) => {
            this.$message.success(data);
            this.getproject();
          });
        },
        (cancel) => { }
      );
    },
    //上下架
    putaway (row) {
      var params = {
        id: row.id,
        putaway: !row.putaway
      };
      this.$api.putawayprojectTour(params).then((data) => {
        this.$message.success(data);
        this.getproject();
      });
    },
    // //c处理选中的icon'图片
    // showSelectedImages(item,id) {
    //  console.log(id);
    //   var obj ={
    //     name :item.name,
    //     pics:item.pics
    //   }
    //   // console.log(url);
    //   this.formData.servicePackage.push(obj)
    //  let newarray = [...new Set(this.formData.servicePackage)] // 去重
    //   console.log(newarray);
    //   // const selectedImages = this.servicePackage.filter(image => image.pics);
    //   // selectedImages.forEach(image => {
    //   //   console.log(image.name);
    //   //   // 在这里可以进行展示被选中图片的操作
    //   // });
    // },
    //处理子组件相册图片数据
    albumokevent (data) {
      this.formData.Projectimage = data
      const obj = data
      const keys = Object.keys(obj);
      const values = keys.map(key => obj[key]);
      const obj1 = values[0]
      const obj2 = values[1]
      const obj3 = values[2]
      const mergedArray = [].concat(Object.values(obj1), Object.values(obj2), Object.values(obj3));
      this.album = mergedArray
      console.log(this.album);
    },
    close () {
      this.dialogVisible = false
    },
    handleConfirm () {
      this.$refs['elform'].validate(valid => {
        if (valid) {
          // console.log(this.formData, '==');
          var params = {
            city: this.formData.city,
            id: this.formData.id ? this.formData.id : '',
            entryname: this.formData.entryname,
            itemlabel: this.formData.itemlabel,
            Projectfloor: this.formData.Projectfloor,
            adress: this.formData.adress,
            projectarea: this.formData.projectarea,
            cyfx: this.formData.cyfx,
            advantage: this.formData.advantage,
            Design: this.formData.Design,
            rating: this.formData.rating,
            Projectimage: this.formData.Projectimage,
            hotel: this.formData.hotel,
            bank: this.formData.bank,
            ShoppingMall: this.formData.ShoppingMall,
            Restaurant: this.formData.Restaurant,
            government: this.formData.government,
            Attractions: this.formData.Attractions,
            // featureSpace:this.formData.[],      
            servicePackage: this.formData.servicePackage,
            listorder: this.formData.listorder,
            videoCover: this.formData.videoCover,
            videoUrl: this.formData.videoUrl,
            type: this.formData.radio,
            status: this.formData.status
          }
          // console.log(params,'params');
          this.$api.addprojectTour(params).then(
            data => {
              //  this.$message.success('操作成功')
              //  this.dialogVisible= false 
              //   this.formData = {}
              // console.log(res,'========');
              if (data == "添加成功" || data == "修改成功") {
                var that = this
                that.$message.success('操作成功')
                that.dialogVisible = false
                // that.formData = {}
                that.getproject()
              } else {
                that.$message.error('遇到了些问题')
              }
              // console.log(data);
            })
        } else {
          this.$message.error('遇到了某些错误,请检查表单')
          return false;
        }

      })
    },

    handleAvatarSuccess (res) {
      let { data, msg } = res;
      if (data) {
        this.$message.success(msg);
        this.formData.videoCover = data;
        this.$forceUpdate()
      } else {
        this.$message.error(msg);
      }
    },
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      // const isLt2M = file.size / 1024 / 1024 < 1;
      if (!isJPG && !isPNG) {
        this.$message.error('只能上传图片，不能上传其他文件!');
      }
      // if (!isLt2M) {
      //     this.$message.error('上传的图片大小不能超过 1MB!');
      // }

      return isJPG || isPNG;
    },
    // 验证视频格式
    beforeUploadVideo (file) {
      // 获取视频时长

      console.log(file)
      if (
        [
          'video/mp4',
          'video/ogg',
          'video/flv',
          'video/avi',
          'video/wmv',
          'video/rmvb'
        ].indexOf(file.type) === -1
      ) {
        this.$message.error('请上传正确的视频格式')
        return false
      }
      // 主要代码模块
      // 获取视频时长
      const url = URL.createObjectURL(file)
      const audioElement = new Audio(url)
      let duration
      const fun = (duration) => {
        this.durationtime = duration
      }
      // 下面需要注意的是在监听loadedmetadata绑定的事件中对duration直接进行赋值是无效的，需要在fun回调函数中进行赋值
      audioElement.addEventListener('loadedmetadata', function () { // 音频/视频的元数据已加载时，会发生 loadedmetadata 事件
        duration = audioElement.duration // 时长以秒作为单位
        fun(parseFloat(duration).toFixed(1))
      })
    },
    // 上传进度显示
    uploadVideoProcess (event, file, fileList) {
      this.videoFlag = true
      this.videoUploadPercent = Math.floor(event.percent)
    },
    // 获取上传视频地址
    handleVideoSuccess (res, file) {
      console.log(res, file)
      this.videoFlag = false
      this.videoUploadPercent = 0
      if (res.msg === '上传成功') {
        this.videoForm.storageurl = res.data
        this.formData.videoUrl = this.videoForm.storageurl
      } else {
        this.$message.error('视频上传失败，请重新上传！')
      }
    },

    confirm () {
      this.pageNo = 1;
      this.getproject();
    },
    currentChange (page) {
      this.pageNo = page;
      this.getproject();
    },
    //查询列表
    getproject () {
      var params = {
        entryname: this.search.entryname,
        pageNo: this.pageNo,
        pagesize:this.pagesize
      }
      this.$api.getprojectTour(params).then(data => {
        console.log(data);
        let { list, total } = data
        this.tabledata = list
        this.total = total;
      })
    },
    getTableData () {
      var params = {
        name: ''
      }
      this.$api.getprojectFacilityIconSubmission(params).then(data => {
        let { list } = data;
        this.servicePackage = list;

        console.log(this.servicePackage, '===');
        // this.total = total;
      })
    },
  },

}
</script>

<style lang="scss" scoped>
.el-rate {
  display: inline-block;
  vertical-align: text-top;
}

.el-upload__tip {
  line-height: 1.2;
}

.right-edit-box {
  position: absolute;
  right: 0;
  top: 0;
}

.el-carousel__item {
  background: #fff;
  border: 1px dashed #999;

  .img {
    width: 270px;
    height: 202px;
    vertical-align: middle;
    position: relative;
  }

  .name {
    position: absolute;
    color: #fff;
    padding: 0 6px;
    background: rgba(0, 0, 0, 0.4);
    bottom: 4px;
    left: 4px;
  }
}

.left-row {
  border: 1px dashed #d9d9d9
}


.formbox {
  display: flex;
  flex-direction: wrap;

  width: 600px;

  .servicebox {
    margin-left: 10px;
    width: 100px;
    height: 100px;
    margin: 10px;
    padding-bottom: 20px;

    .boximage {
      width: 100px;
      height: 100px;
      display: flex;
    }
  }
}

.avatar {
  width: 300px;
  height: 240px;
  display: block;
}

.videoCoverimg {
  width: 200px;
  height: 200px;
}
</style>